import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import axios from "axios";
import url from "../../function/url";

function PremiumMembershipManagerCompany() {
  const [companies, setCompanies] = useState([]);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [telecallers, setTelecallers] = useState({});
  const [telecallerOptions, setTelecallerOptions] = useState([]);

  useEffect(() => {
    fetchCompanies(`${url.path}/premiumManageremployees/`);
    fetchTelecallers();
  }, []);

  const fetchCompanies = async (apiUrl) => {
    try {
      const response = await axios.get(apiUrl);

      const companiesData =
        response.data.companies?.results || response.data.companies || [];

      setCompanies(companiesData);
      setFilteredCompanies(companiesData);

      const initialTelecallers = {};
      companiesData.forEach((cmp) => {
        initialTelecallers[cmp.login_id] = "";
      });
      setTelecallers(initialTelecallers);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const fetchTelecallers = async () => {
    try {
      const response = await axios.get(`${url.path}/getTelecallers/`);
      setTelecallerOptions(response.data);
    } catch (error) {
      console.error("Error fetching telecallers:", error);
    }
  };

  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTerm(searchValue);

    const filtered = companies.filter(
      (company) =>
        (company.Company_Name &&
          company.Company_Name.toLowerCase().includes(searchValue)) ||
        (company.Email && company.Email.toLowerCase().includes(searchValue))
    );

    setFilteredCompanies(filtered);
  };

  const handleTelecallerChange = (e, login_id) => {
    setTelecallers({ ...telecallers, [login_id]: e.target.value });
  };

  // const handleStatusChange = async (company) => {
  //   const currentStatus = company.Status || "Pending";
  //   const newStatus = currentStatus === "Pending" ? "Assigned" : "Pending";

  //   const telecallerId = telecallers[company.login_id] || "";
  //   const selectedTelecaller = telecallerOptions.find(
  //     (t) => t.id === Number(telecallerId)
  //   );
  //   const telecallerName = selectedTelecaller ? selectedTelecaller.name : "";

  //   try {
  //     const response = await axios.post(`${url.path}/updateMembershipStatus/`, {
  //       login_id: company.login_id,
  //       status: newStatus,
  //       telecallerId: telecallerId,
  //       telecallerName: telecallerName,
  //     });

  //     const updatedStatus = response.data?.data?.[0]?.Status || newStatus;

  //     setCompanies((prevCompanies) =>
  //       prevCompanies.map((cmp) =>
  //         cmp.login_id === company.login_id
  //           ? { ...cmp, Status: updatedStatus }
  //           : cmp
  //       )
  //     );
  //     console.log("New Status", newStatus);
  //     setFilteredCompanies((prevCompanies) =>
  //       prevCompanies.map((cmp) =>
  //         cmp.login_id === company.login_id
  //           ? { ...cmp, Status: updatedStatus }
  //           : cmp
  //       )
  //     );
  //   } catch (error) {
  //     console.error("Error updating status:", error);
  //   }
  //   fetchCompanies(`${url.path}/premiumManageremployees/`);
  // };

  const handleStatusChange = async (company) => {
    const telecallerId = telecallers[company.login_id] || "";
    const selectedTelecaller = telecallerOptions.find(
      (t) => t.id === Number(telecallerId)
    );
    const telecallerName = selectedTelecaller ? selectedTelecaller.name : "";
  
    if (!telecallerId) {
      alert("Please select a telecaller before updating the status.");
      return;
    }
  
    const currentStatus = company.Status || "Pending";
    const newStatus = currentStatus === "Pending" ? "Assigned" : "Pending";
  
    try {
      const response = await axios.post(`${url.path}/updateMembershipStatus/`, {
        login_id: company.login_id,
        status: newStatus,
        telecallerId: telecallerId,
        telecallerName: telecallerName,
      });
  
      const updatedStatus = response.data?.data?.[0]?.Status || newStatus;
  
      setCompanies((prevCompanies) =>
        prevCompanies.map((cmp) =>
          cmp.login_id === company.login_id
            ? { ...cmp, Status: updatedStatus }
            : cmp
        )
      );
      setFilteredCompanies((prevCompanies) =>
        prevCompanies.map((cmp) =>
          cmp.login_id === company.login_id
            ? { ...cmp, Status: updatedStatus }
            : cmp
        )
      );
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };
  

  return (
    <>
      <Navbar />
      <center>
        <h3 style={{ fontSize: "20px", position: "relative", top: "10px" }}>
          Premium Membership
        </h3>
      </center>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "10px",
        }}
      >
        <input
          type="text"
          value={searchTerm}
          onChange={handleSearch}
          placeholder="Search by name, email, or contact..."
          className="search-input"
          style={{
            width: "250px",
            padding: "8px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            textAlign: "center",
          }}
        />
      </div>

      <div className="table-container">
        <table className="responsive-table" id="productstable">
          <thead className="bg-gray-200">
            <tr>
              <th className="border border-gray-300 px-4 py-2">Company Name</th>
              <th className="border border-gray-300 px-4 py-2">Email</th>
              <th className="border border-gray-300 px-4 py-2">
                Package Taken
              </th>
              <th className="border border-gray-300 px-4 py-2">Telecaller</th>
              <th className="border border-gray-300 px-4 py-2">Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredCompanies.length > 0 ? (
              filteredCompanies.map((company) => (
                <tr
                  key={company.login_id || company.Email}
                  className="bg-white"
                >
                  <td className="border border-gray-300 px-4 py-2">
                    {company.Company_Name || "N/A"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {company.Email || "N/A"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {company.PackageTaken || "N/A"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    <select
                      // value={company.Telecaller||""}
                      value={
                        telecallers[company.login_id] ||
                        company.Telecaller ||
                        ""
                      }
                      onChange={(e) =>
                        handleTelecallerChange(e, company.login_id)
                      }
                      className="border px-2 py-1 rounded"
                    >
                      <option value="">Select Telecaller</option>
                      {telecallerOptions.map((telecaller) => (
                        <option key={telecaller.id} value={telecaller.id}>
                          {telecaller.name}
                        </option>
                      ))}
                    </select>
                  </td>

                  <td className="border border-gray-300 px-4 py-2">
                    <button
                      onClick={() => handleStatusChange(company)}
                      disabled={
                        company.Status === "Assigned" ||
                        company.Status === "Approved"
                      }
                      // disabled={company.Status === "Assigned" || "Approved"}
                      className={`px-4 py-2 text-white rounded ${
                        company.Status === "Assigned"
                          ? "bg-green-500 hover:bg-green-700"
                          : "bg-yellow-500 hover:bg-yellow-700"
                      }`}
                    >
                      {company.Status || "Pending"}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center py-4">
                  No companys found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default PremiumMembershipManagerCompany;
